import "./tableheadercontent.scss"
import FilterIcon from "../../modules/icons/filter";
import SearchInput from "../searchinput/searchinput";

interface ITableHeaderContent {
    title: string
    subtitle: string
    placeholder: string
    onClick: () => void
}

const TableHeaderContent = ({title, subtitle, placeholder, onClick}: ITableHeaderContent) => {
    return (
        <div className="Table-Header-Content">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                <h6 className="Table-Header-Content-Title">
                    {title}
                    &nbsp;&nbsp;
                    <span className="Table-Header-Content-Subtitle">
                       {subtitle}
                    </span>
                </h6>
                <button onClick={onClick} className="Export-Button">
                    فیلتر
                    &nbsp;&nbsp;
                    <FilterIcon/>
                </button>
            </div>
            <SearchInput placeholder={placeholder}/>
        </div>
    )
}

export default TableHeaderContent